import React from 'react';

export default function ModeSwitchButton() {
  return (
    <a href="/" className="mode-switch-btn">
      Back to Fedora OS
    </a>
  );
}
